<div ng-include="'views/painel_propriedade/aplicacao/_recomendacao.html'"></div>

<div class="title text-center">
  <h2 class="f-size-22">EDITANDO AUDITORIA</h2>
</div>

<span class="input-group-addon no-border no-background" ng-show="loadingAplicacao">
  <i class="fa fa-spinner fa-spin"></i>
</span>

<form id="aplicacao_form" name="aplicacao_form" novalidate blur-on-submit ng-submit="save(aplicacao_form)" ng-hide="loadingAplicacao">
  <!-- safra -->
  <div class="width-100" ng-if="!isTratamentoSemente">
    <div class="form-group">
      <input type="text" ng-value="aplicacao.safra.descricao" readonly id="safra" name="safra" class="form-control">
    </div>
  </div>

  <!-- data inicial -->
  <div class="width-100">
    <div class="form-group" ng-class="{'has-error': aplicacao_form.dataInicio.$invalid}">
      <div class="input-group">
        <input type="text" class="form-control" readonly datepicker-options="datePickerOptions" placeholder="Data inicial"
          uib-datepicker-popup="{{calendar.format}}" ng-model="aplicacao.dt_ini"
          is-open="calendar.startOpen" show-button-bar="false" datepicker-append-to-body="true"
          id="dataInicio" name="dataInicio" required ng-if="!isTratamentoSemente">
        <input type="text" class="form-control" readonly datepicker-options="datePickerOptions" placeholder="Data inicial"
          uib-datepicker-popup="{{calendar.format}}" ng-model="aplicacao.atributo_attributes.data_hora_inicio"
          is-open="calendar.startOpen" show-button-bar="false" datepicker-append-to-body="true"
          id="dataInicio" name="dataInicio" required ng-if="isTratamentoSemente">
        <span class="input-group-btn">
          <button type="button" class="btn btn-default" ng-click="calendar.startOpen = true">
            <i class="glyphicon glyphicon-calendar"></i>
          </button>
        </span>
      </div>
      <p class="help-block" ng-show="aplicacao_form.dataInicio.$dirty && aplicacao_form.dataInicio.$error.required">Informe a data inicial</p>
    </div>
  </div>

  <!-- data final -->
  <div class="width-100">
    <div class="form-group" ng-class="{'has-error': aplicacao_form.dataTermino.$invalid}">
      <div class="input-group">
        <input type="text" class="form-control" readonly datepicker-options="datePickerOptions" placeholder="Data final"
          uib-datepicker-popup="{{calendar.format}}" ng-model="aplicacao.dt_fim"
          is-open="calendar.endOpen" show-button-bar="false" datepicker-append-to-body="true"
          id="dataTermino" name="dataTermino" required ng-if="!isTratamentoSemente">
        <input type="text" class="form-control" readonly datepicker-options="datePickerOptions" placeholder="Data final"
          uib-datepicker-popup="{{calendar.format}}" ng-model="aplicacao.atributo_attributes.data_hora_fim"
          is-open="calendar.endOpen" show-button-bar="false" datepicker-append-to-body="true"
          id="dataTermino" name="dataTermino" required ng-if="isTratamentoSemente">
        <span class="input-group-btn">
          <button type="button" class="btn btn-default" ng-click="calendar.endOpen = true">
            <i class="glyphicon glyphicon-calendar"></i>
          </button>
        </span>
      </div>
      <p class="help-block" ng-show="aplicacao_form.dataInicio.$dirty && aplicacao_form.dataInicio.$error.required">Informe a data final</p>
    </div>
  </div>

  <!-- atividade -->
  <div class="width-100" ng-if="!isTratamentoSemente && !isCorrecaoSolo">
    <div class="form-group">
      <input type="text" ng-value="aplicacao.atividade.descricao" readonly id="atividade" name="atividade" class="form-control">
    </div>
  </div>

  <!-- gleba -->
  <div class="width-100" ng-if="!isTratamentoSemente">
    <div class="form-group">
      <input type="text" ng-value="aplicacao.gleba.descricao" readonly id="gleba" name="gleba" class="form-control">
    </div>
  </div>

  <!-- pulverizador -->
  <div class="width-100" ng-if="!isTratamentoSemente && aplicacao.tipoOperacao != 'operacao_semeadura'">
    <div class="form-group" ng-class="{'has-error': aplicacao_form.pulverizador.$invalid}">
      <ui-select ng-model="aplicacao.pulverizador" theme="bootstrap" id="pulverizador" name="pulverizador" required>
        <ui-select-match allow-clear="true" placeholder="Máquina">{{$select.selected.descricao | humanize | characters:30}}</ui-select-match>
        <ui-select-choices repeat="pulverizador in sprayers | orderBy: 'descricao' | filter: $select.search">
          <span class="form-group" ng-bind-html="pulverizador.descricao | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>
      <p class="help-block" ng-show="aplicacao_form.pulverizador.$invalid">Informe a máquina</p>
    </div>
  </div>

  <!-- Tanques -->
  <div ng-if="!isTratamentoSemente && aplicacao.tipoConsumo.id === 'tanque'"></divng-if>
    <div class="width-100">
      <div class="form-group" ng-class="{'has-error': aplicacao_form.tanques.$invalid}">
        <div class="input-group">
          <input class="form-control" placeholder="Tanques " ng-model="aplicacao.nr_tanques"
                    ng-change="changeConsumo()" type="number" id="tanques" name="tanques" required
                    ng-pattern="/^\d*(?=.*[1-9])\d*(?:[\.\,]\d{1,4})?\s*$/"/>
          <span class="input-group-addon">tanques</span>
        </div>
        <p class="help-block" ng-show="aplicacao_form.tanques.$error.required">Informe o número de tanques consumidos</p>
        <p class="help-block" ng-show="aplicacao_form.tanques.$error.pattern">Número de tanques inválido. Ex.: 10,5555</p>
      </div>
    </div>
    <div class="width-100">
      <div class="form-group" ng-class="{'has-error': aplicacao_form.capacidade.$invalid}">
        <div class="input-group">
          <input class="form-control" placeholder="Capacidade Tanque" ng-model="aplicacao.parametros.capacidade_tanque"
                    ng-change="changeConsumo()" type="number" id="capacidade" name="capacidade" required
                    ng-pattern="/^\s*(?=.*[1-9])\d*(?:[\.\,]\d{1,2})?\s*$/"/>
          <span class="input-group-addon">litros</span>
        </div>
        <p class="help-block" ng-show="aplicacao_form.tanques.$error.required">Informe capacidade do tanque em litros</p>
        <p class="help-block" ng-show="aplicacao_form.tanques.$error.pattern">Número litros. Ex.: 10,55</p>
      </div>
    </div>
    <div class="width-100">
      <div class="form-group" ng-class="{'has-error': aplicacao_form.tanques.$invalid}">
        <div class="input-group">
          <input class="form-control" placeholder="Vazão" ng-model="aplicacao.parametros.vazao"
                    ng-change="changeConsumo()" type="number" id="vazao" name="vazao" required
                    ng-pattern="/^\s*(?=.*[1-9])\d*(?:[\.\,]\d{1,2})?\s*$/"/>
          <span class="input-group-addon">l/ha</span>
        </div>
        <p class="help-block" ng-show="aplicacao_form.vazao.$error.required">Informe a vazão em l.</p>
        <p class="help-block" ng-show="aplicacao_form.vazao.$error.pattern">Número de tanques inválido. Ex.: 10,55</p>
      </div>
    </div>
  </div>
  <!-- fim tanques -->

  <!-- Área -->
  <div class="width-100" ng-if="!isTratamentoSemente">
    <div class="form-group" ng-class="{'has-error': aplicacao_form.area.$invalid}">
      <div class="input-group">
        <input class="form-control" placeholder="Área"
                  ng-model="aplicacao.areaAplicada"
                  ng-change="changeArea()" type="number"
                  id="area" name="area" required
                  ng-disabled="aplicacao.tipoConsumo.id === 'tanque'"
                  ng-pattern="/^\s*(?=.*[1-9])\d*(?:[\.\,]\d{1,2})?\s*$/"/>
        <span class="input-group-addon">ha</span>
      </div>
      <p class="help-block" ng-show="aplicacao_form.area.$error.required">Informe a área</p>
      <p class="help-block" ng-show="aplicacao_form.area.$error.pattern">Área inválida. Ex.: 10,55</p>
    </div>
  </div>

  <!-- Quantidade semente tratada -->
  <div class="width-100" ng-if="isTratamentoSemente && !isSegundoTratamento()">
    <div class="form-group" ng-class="{'has-error': aplicacao_form.quantidade.$invalid}">
      <input class="form-control" placeholder="Quantidade" ng-model="aplicacao.quantidade"
                ng-change="changeQuantidade()" type="number" id="quantidade" name="quantidade" required
                ng-pattern="/^\s*(?=.*[1-9])\d*(?:[\.\,]\d{1,2})?\s*$/"/>
      <p class="help-block" ng-show="aplicacao_form.quantidade.$error.required">Informe a quantidade</p>
      <p class="help-block" ng-show="aplicacao_form.quantidade.$error.pattern">Quantidade inválida. Ex.: 10,55</p>
    </div>
  </div>

  <!-- segundo tratamento -->
  <div class="width-100" ng-if="isTratamentoSemente && !temRecomendacaoTratamento">
    <div class="form-group">
      <input type="checkbox" ng-model="aplicacao.atributo_attributes.segundo_tratamento" id="tratamento" name="tratamento" disabled> 2º Tratamento
    </div>
  </div>

  <!-- produtos -->
  <div class="width-100 products">
    <div class="form-group no-margin">
      <ui-select ng-model="produto.selected" on-select="addProduto($item)" theme="bootstrap" id="produtos" name="produtos">
        <ui-select-match allow-clear="true" placeholder="Digite a descrição do produto">{{$select.selected.descricao}}</ui-select-match>
        <ui-select-choices repeat="produto in produtos" refresh="searchProdutos($select)" refresh-delay="300">
          <div ng-bind-html="produto.descricao | highlight: $select.search"></div>
          <span ng-show="$root.permissions.estoque.canViewStock && $root.parametros.tem_controle_de_estoque">
            <small ng-bind-html="'Físico: ' + (produto.saldo_fisico | number:4) + ' ' + (produto.unidade.abreviatura)"></small><br>
            <small ng-bind-html="'Em uso: ' + (produto.saldo_em_uso | number:4) + ' ' + (produto.unidade.abreviatura)"></small>
            <small ng-bind-html="' / A Receber: ' + (produto.saldo_receber | number:4) + ' ' + (produto.unidade.abreviatura)"></small>
          </span>
        </ui-select-choices>
      </ui-select>
      <small class="help-block" ng-show="searchProduto.length && !loadingProdutos && !produtos">
        Informe pelo menos 3 caracteres
      </small>
      <span class="input-group-addon no-border no-background" ng-show="loadingProdutos">
        <i class="fa fa-spinner fa-spin"></i>
      </span>
      <span class="input-group-addon no-border no-background" ng-show="!loadingProdutos && produtos.length === 0">
        Não encontrado
      </span>
    </div>
    <button type="button" class="btn btn-white" title="Ver todos os produtos" ng-click=" openProductModal()">
      <i class="fa fa-external-link"></i>
    </button>
  </div>

  <p ng-if="fatorDose > 1" class="m-t-sm">
    <b>Atenção:</b> A dose é para cada {{fatorDose}}kg
  </p>

  <div class="width-100 danger-on-error-form">
    <small class="text-danger" ng-hide="aplicacao.produtos.length"><br>Nenhum produto na aplicação!<br></small>

    <div class="form-group m-t-xs padding-top-10" ng-repeat="produto in aplicacao.produtos track by $index">
      <p class="no-margin" uib-tooltip="{{produto.descricao + (stockIsNegative(produto) ? ' - Estoque Negativo' : '')}}"
         ng-class="{'btn-danger': stockIsNegative(produto)}">
        <b>{{produto.descricao | characters:30}}</b>
      </p>

      <div class="width-90 inline-flex">
        <input
          ng-if="!isDecimalV2Enabled && !isSegundoTratamento()"
          title="Dose"
          class="form-control p-xxs"
          placeholder="Dose"
          ng-model="produto.dose"
          fixed-decimal-input
          type="text"
          inputmode="decimal"
          ng-change="changeDose(produto)"
          required
          ng-blur="fixDose(produto)">
        <input
          ng-if="isDecimalV2Enabled && !isSegundoTratamento()"
          title="Dose"
          class="form-control p-xxs"
          placeholder="Dose"
          ng-focus="startEditDose(produto)"
          ng-model="produto.dose"
          fixed-decimal-input
          type="text"
          inputmode="decimal"
          ng-blur="fixDose(produto)"
          required>

        <div class="input-group-btn width-50" uib-dropdown dropdown-append-to-body>
          <button type="button" class="btn btn-secondary width-100 padding-6" uib-dropdown-toggle>
            {{produto.unidade.abreviatura || 'Unid.'}}
            <span class="caret"></span>
          </button>
          <ul class="dropdown-menu-right" uib-dropdown-menu>
            <li class="dropdown-item" ng-repeat="unidade in produto.unidades">
              <a href="#" ng-click="setUnidade($event, produto, unidade)">{{unidade.abreviatura}}</a>
            </li>
          </ul>
        </div>

        <input
          ng-if="!isDecimalV2Enabled"
          title="Total"
          class="form-control p-xxs"
          placeholder="Total"
          ng-model="produto.quantidadeTotal"
          fixed-decimal-input="milhar"
          type="text"
          inputmode="decimal"
          ng-change="changeQuantidadeTotal(produto)"
          required
          ng-blur="fixQuantidadeTotal(produto)">
        <input
          ng-if="isDecimalV2Enabled"
          title="Total"
          class="form-control p-xxs"
          placeholder="Total"
          ng-focus="startEditQuantidadeTotal(produto)"
          ng-model="produto.quantidadeTotal"
          fixed-decimal-input="milhar"
          type="text"
          inputmode="decimal"
          ng-blur="fixQuantidadeTotal(produto)"
          required>
      </div>
      <span type="button" class="btn width-10 pull-right p-xxs" ng-click="removeProduto($index)">
        <i class="fa fa-times fa-lg" aria-hidden="true"></i>
      </span>
      <div class="area-produto clearfix" ng-if="!isTratamentoSemente">
        <h6>
          <span ng-if="!!produto.area">em <b>{{ produto.area|number:2 }}ha</b></span>
        </h6>
        <span type="button" class="btn width-50 pull-right p-xxs" ng-click="specifyProductArea(produto)">Alterar área</span>
      </div>

      <div ng-if="(produto.controlaLote || produto.controla_lote)">
        <small ng-if="produto.loadingLotes">Carregando lotes...</small>
        <p class="text-danger" ng-if="!produto.loadingLotes && !produto.lotes.length">Nenhum lote encontrado para o produto.</p>
        <ui-select ng-if="!produto.loadingLotes" ng-model="produto.selected" on-select="addLote($item, produto)"  theme="bootstrap" id="lotes" name="lotes">
          <ui-select-match allow-clear="true" placeholder="Digite o número do lote">{{$select.selected.nrLote}}</ui-select-match>
          <ui-select-choices repeat="lote in getLotes(produto) | filter: $select.search | limitTo: 50">
            <div ng-bind-html="lote.nrLote"></div>
            <span ng-show="$root.permissions.estoque.canViewStock && $root.parametros.tem_controle_de_estoque">
              <small ng-bind-html="'Físico: ' + (lote.fisico | number:4) + ' ' + (lote.unidade.abreviatura) + ' | Uso: ' + (lote.emUso | number:2) + ' | Venc.: ' + (lote.dataValidadeLote | date:'dd/MM/yyyy')"></small>
            </span>
          </ui-select-choices>
        </ui-select>

        <div ng-if="produto.lote && aplicacao.tipoOperacao !== 'operacao_tratamento_semente'">
          <b>Lote nº {{produto.lote.nrLote}}</b>
        </div>

        <div ng-if="produto.nr_lote && aplicacao.tipoOperacao === 'operacao_tratamento_semente'">
          <b>Lote nº {{produto.nr_lote}}</b>
        </div>
      </div>
    </div>
  </div>

  <div class="clearfix"></div>
  <br>

  <!-- Temperatura -->
  <div class="width-100" ng-if="!isTratamentoSemente">
    <div class="form-group" ng-class="{'has-error': aplicacao_form.temperatura.$invalid}">
      <div class="input-group">
        <input class="form-control" placeholder="Temperatura" ng-model="aplicacao.condicoes.temperatura.final"
                  type="number" id="temperatura" name="temperatura"
                  ng-pattern="/^[0-9]+([\.\,][0-9]{1,2})?$/">
        <span class="input-group-addon">°C</span>
      </div>
      <p class="help-block" ng-show="aplicacao_form.temperatura.$invalid">Valor inválido</p>
    </div>
  </div>

  <!-- Umidade -->
  <div class="width-100" ng-if="!isTratamentoSemente">
    <div class="form-group" ng-class="{'has-error': aplicacao_form.umidade.$invalid}">
      <div class="input-group">
        <input class="form-control" placeholder="Umidade Rel. do Ar" ng-model="aplicacao.condicoes.umidade.final"
                  type="number" id="umidade" name="umidade"
                  ng-pattern="/^[0-9]+([\.\,][0-9]{1,2})?$/">
        <span class="input-group-addon">%</span>
      </div>
      <p class="help-block" ng-show="aplicacao_form.umidade.$invalid">Valor inválido</p>
    </div>
  </div>

  <!-- Velocidade do Vento-->
  <div class="width-100" ng-if="!isTratamentoSemente">
    <div class="form-group" ng-class="{'has-error': aplicacao_form.vento.$invalid}">
      <div class="input-group">
        <input class="form-control" placeholder="Velocidade do vento" ng-model="aplicacao.condicoes.vento.maxima"
                  type="number" id="vento" name="vento" auto-step
                  ng-pattern="/^[0-9]+([\.\,][0-9]{1,1})?$/">
        <span class="input-group-addon">km/h</span>
      </div>
      <p class="help-block" ng-show="aplicacao_form.vento.$invalid">Valor inválido</p>
    </div>
  </div>

  <!-- Horas sem Chuva -->
  <div class="width-100" ng-if="!isTratamentoSemente">
    <div class="form-group" ng-class="{'has-error': aplicacao_form.horas.$invalid}">
      <input class="form-control" placeholder="Horas sem chuva" ng-model="aplicacao.condicoes.horasSemChuva"
                type="number" id="horas" name="horas" auto-step
                ng-pattern="/^[0-9]+([\.\,][0-9]{1,1})?$/">
      <p class="help-block" ng-show="aplicacao_form.horas.$invalid">Valor inválido</p>
    </div>
  </div>

  <div class="width-100" ng-if="aplicacao.obs">
    <div class="form-group">
      <label>Observações</label>
      <textarea class="form-control" ng-model="aplicacao.obs" disabled></textarea>
    </div>
  </div>

  <div class="m-t-sm m-b-sm">
    <historico-alteracoes id="{{id}}" type="AuditoriaAplicacao" />
  </div>

  <div class="btn-group btn-group-justified">
    <div class="btn-group">
      <button class="btn btn-primary" type="submit" ng-disabled="aplicacao_form.$invalid || loadingSave || !aplicacao.produtos.length">
        Salvar
        <span ng-show="loadingSave">
          <i class="fa fa-spinner fa-spin"></i>
        </span>
      </button>
    </div>

    <div class="btn-group">
      <button class="btn btn-default" type="button" ng-click="cancel()"
              ng-disabled="loadingSave">
        Cancelar
      </button>
    </div>
  </div>
</form>
